import ChannelIcon from "../../../components/ChannelIcon.js";
import {request} from "../../../utils/request/index.js";
import {CopyOutlined, ShopOutlined} from "../../../../__snowpack__/pkg/@ant-design/icons.js";
import {useRequest, useSelections} from "../../../../__snowpack__/pkg/ahooks.js";
import {Checkbox, Col, Empty, Modal, Row, Space, Spin, Typography} from "../../../../__snowpack__/pkg/antd.js";
import classNames from "../../../../__snowpack__/pkg/classnames.js";
import _ from "../../../../__snowpack__/pkg/lodash.js";
import React, {useMemo} from "../../../../__snowpack__/pkg/react.js";
import {useIntl} from "../../../../__snowpack__/pkg/react-intl.js";
import styles from "./index.module.css";
const SHOULD_IGNORE_CHANNELS = [
  "JD_ID",
  "JD_V2",
  "TIKI_ID",
  "ZALORA_ID",
  "AKULAKU_ID",
  "JD_TH",
  "MOKA_POS_ID",
  "MANUAL_ID",
  "MAGENTO_ID",
  "WIX_ID",
  "GINEE_POS"
];
export default function CloneProductsModal(props) {
  const {productIds, onClose, countryCode} = props;
  const {formatMessage} = useIntl();
  const {data, loading: shopsLoading} = useRequest((_params) => request.post("/infra/integration/my/search", {
    application: "SYS_ERP",
    authorizationStatus: "CONNECTED",
    integrationType: "MARKETPLACE"
  }), {ready: !!productIds.length, refreshDeps: productIds});
  const shops = useMemo(() => {
    if (!data) {
      return [];
    }
    return data?.map((item) => {
      return {
        ...item,
        channelName: item?.integrationMarketplaceName || "",
        channelId: item?.integrationMarketplace || "",
        shopName: item?.name || ""
      };
    });
  }, [data]);
  const filteredShops = shops?.filter((shop) => {
    if (countryCode) {
      return !SHOULD_IGNORE_CHANNELS.includes(shop?.channelId) && shop?.countryCode === countryCode;
    }
    return !SHOULD_IGNORE_CHANNELS.includes(shop?.channelId);
  });
  const channels = _.uniqBy(filteredShops?.filter((shop) => shop?.countryCode === countryCode).map((shop) => ({
    id: shop?.channelId,
    name: shop?.channelName
  })), "id");
  const channelSelections = useSelections(channels.map((channel) => channel.id));
  const selectedChannel = channelSelections.selected?.[0];
  const selectableShops = filteredShops.filter((shop) => shop?.channelId === selectedChannel);
  const shopSelections = useSelections(selectableShops.map((shop) => shop?.id));
  const {runAsync: cloneProducts, loading: cloneProductsLoading} = useRequest(() => request.post("/saas/product/batch_clone", {
    productIds,
    targetShopIds: shopSelections.selected
  }), {
    manual: true,
    onSuccess: (taskId) => {
      onClose(taskId);
    }
  });
  const CheckShopsEmpty = useMemo(() => ({children}) => {
    if (!filteredShops.length) {
      return /* @__PURE__ */ React.createElement(Empty, {
        description: formatMessage({id: "thereIsNoStoreThatSupports"})
      });
    }
    return children;
  }, [!!filteredShops.length]);
  return /* @__PURE__ */ React.createElement(Modal, {
    title: formatMessage({id: "copyProduct"}),
    visible: !!productIds.length,
    width: 700,
    okText: formatMessage({id: "copyToDraft"}),
    okButtonProps: {disabled: shopsLoading || !(selectedChannel && shopSelections?.selected?.length)},
    confirmLoading: cloneProductsLoading,
    onOk: () => {
      return cloneProducts();
    },
    onCancel: () => {
      onClose();
    },
    afterClose: () => {
      channelSelections.unSelectAll();
      shopSelections.unSelectAll();
    }
  }, /* @__PURE__ */ React.createElement(Spin, {
    spinning: shopsLoading
  }, /* @__PURE__ */ React.createElement(CheckShopsEmpty, null, /* @__PURE__ */ React.createElement(Space, {
    style: {marginBottom: 8}
  }, /* @__PURE__ */ React.createElement(Typography.Text, {
    style: {fontSize: 14}
  }, /* @__PURE__ */ React.createElement(CopyOutlined, {
    style: {color: "#606C80", marginRight: 8}
  }), formatMessage({id: "countProductClonedTo"}, {count: productIds.length}), ":")), /* @__PURE__ */ React.createElement(Row, {
    gutter: [8, 8],
    style: {marginBottom: 16}
  }, channels.map((channel) => /* @__PURE__ */ React.createElement(Col, {
    span: 6,
    key: channel.id
  }, /* @__PURE__ */ React.createElement("div", {
    className: classNames({
      [styles["channel-item"]]: true,
      [styles["channel-item--checked"]]: channelSelections.isSelected(channel.id)
    }),
    onClick: () => {
      if (channelSelections.isSelected(channel.id)) {
        return;
      }
      channelSelections.unSelectAll();
      channelSelections.toggle(channel.id);
      shopSelections.unSelectAll();
    }
  }, /* @__PURE__ */ React.createElement(ChannelIcon, {
    channelId: channel.id
  }), /* @__PURE__ */ React.createElement("span", null, channel.name))))), !!selectableShops.length && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", {
    style: {marginBottom: 8}
  }, /* @__PURE__ */ React.createElement(Typography.Text, {
    style: {fontSize: 14}
  }, /* @__PURE__ */ React.createElement(ShopOutlined, {
    style: {color: "#606C80", marginRight: 8}
  }), formatMessage({id: "selectStore"}), ":")), /* @__PURE__ */ React.createElement(Row, {
    gutter: [8, 8],
    style: {
      maxHeight: 240,
      overflowY: "auto"
    }
  }, selectableShops?.map((shop) => /* @__PURE__ */ React.createElement(Col, {
    span: 6,
    key: shop.id
  }, /* @__PURE__ */ React.createElement(Checkbox, {
    value: shop.id,
    style: {whiteSpace: "nowrap"},
    checked: shopSelections.isSelected(shop.id),
    onChange: () => {
      shopSelections.toggle(shop.id);
    }
  }, /* @__PURE__ */ React.createElement(Typography.Text, {
    ellipsis: {tooltip: true},
    style: {maxWidth: 140}
  }, "(", shop.countryCode, ") ", shop.shopName)))))))));
}
